import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getAddressesByCompany } from "../store/thunks/get-addresses";

const useLoadAddresses = () => {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getAddressesByCompany());
	}, [dispatch]);
	const loading = useSelector((store) => store.addresses?.loading);
	return loading;
};

export default useLoadAddresses;
